import React, { useEffect, useContext, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import useValidationInput from "../../../Hooks/useValidationInput.js";
import useAxiosOperation from "../../../Hooks/useAxiosOperation.js";
import SpinnerIcon from "../../Commands/SpinnerIcon/SpinnerIcon.js";
import useLogIcon from "../../../Hooks/useLogIcon.js";
import { useHistory } from "react-router-dom";
import "../../Styles/globalStyle.css";
import { store } from "../../../store.js";
import Cookies from "js-cookie"
import ExpandCommand from "../../Commands/ExpandCommand/ExpandCommand";
import CollapseCommand from "../../Commands/CollapseCommand/CollapseCommand";
import TaskIcon from "../../Commands/TaskIcon/TaskIcon";
import FormIcon from "../../Commands/FormIcon/FormIcon";
import Request from "../Request/List";
import DropDownListNew from "../../DropDownList/DropDownListNew";
import Autocomplete from "../../Autocomplete/Autocomplete";
import Process from "./Process";
import Column from "./Column";
import NextIcon from "../../Commands/NextIcon/NextIcon";
import PreviousIcon from "../../Commands/PreviousIcon/PreviousIcon";
import Steps from "../Request/Steps";


export default function  Gantt (props) {
  const globalState = useContext(store);
  const [process, setProcess] = useState([1]);
  const { dispatch } = globalState;
  const [token, setToken]  = useState(new URLSearchParams(useLocation().search).get("c_token"));
  const getLogIcon = useLogIcon();
  const isInputValid = useValidationInput();
  const axiosOperation = useAxiosOperation();
  const history = useHistory();
  const  [data, setData] = useState({ 
    chartType: "Month",
    email : "",
    password : "",
    errors:[],
    option: {id:1, item:"List"}
  })
  const  [user, setUser] = useState({ 
    id: 1,
    email : "",
    password : "",
    errors:[]
  })
  const days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  
    const getError = (id) => {
    const error =  user.errors.filter(item => item.id == id)[0]
    return <div style={{border:"none", backgroundColor:"transparent", userSelect:"none",
      paddingTop:"0px", marginTop:"0px", height:"15px",  color: "rgb(206, 17, 38)", fontSize: 10}} 
      >{error ? error.text: ""}</div>
  
  };

 
  
  useEffect(() => {
    if (token != null) {
      var userData = JSON.parse(JSON.stringify(user));
      setUser({...userData, loading:true })
      axiosOperation({method:"PATCH"
        , url: "https://flex-services.onrender.com/user/"+ token + "/"
        , body: {confirmed:true, nTry:0}
        }).then(response => 
          { 
            if(response.managedError) {
              const result = response.result.data
              setUser({...userData, log:{type:result.log.type, text:result.log.text, style:result.log.style, activeResendEmail:result.activeReSendEmail}})
            }
            else {
              
              setUser({...userData, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
            }
          })

    }
  }, []); //onLoad

  const fireOtherEvent = (e, detail, typeValidation) => {
  
    var userData = JSON.parse(JSON.stringify(user));
    validInput(e.target.value, detail, typeValidation, userData) 
    setUser(userData);
  }

  const fireEventKeyPress = (e, detail, typeValidations) => {
     
    var userData = JSON.parse(JSON.stringify(user));
    userData.errors = userData.errors.filter(error => error.id != detail.id )

    if(typeValidations,  !isInputValid({value: e.key}, typeValidations).isValid) {
      e.preventDefault()
    }
    setUser(userData);
  }

  const validInput = (value, detail, typeValidation, userData) => {
    const eventResponse = isInputValid({value: value}, typeValidation);
    if(eventResponse.isValid) {
      userData.errors = userData.errors.filter(error => error.id != detail.id )
    }
    else {
      userData.errors.push({id:detail.id
        , text: eventResponse.type == "EMAIL" ? "The email is invalid" : "The field is required".replace("field", detail.name)})
    }
  }

  const onClick = () => {
  
    var userData = JSON.parse(JSON.stringify(user));
    validInput(user.email, {id:"Email", name:"Email" }, [{type :"REQUIRE"}], userData) 
    validInput(user.password, {id:"Password", name:"Password" }, [{type :"REQUIRE"}], userData)
    if (userData.errors.length == 0) {
      var userData = JSON.parse(JSON.stringify(user));
      
      setUser({...userData, loading:true })
      
      if (user.log && user.log.activeResendEmail)
        axiosOperation({method:"POST"
        , url: "https://flex-services.onrender.com/user/"
        , body:userData
        }).then(response => 
          { 
            if(response.managedError) {
              const result = response.result.data
              setUser({...userData, log:{type:result.log.type, text:result.log.text, style:result.log.style, activeResendEmail:result.activeReSendEmail}})
            }
            else {
              setUser({...userData, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
            }
          })
      else
        axiosOperation({method:"POST"
          , url: "https://flex-services.onrender.com/login/"
          , body: userData
          , headers: {xsrfHeaderName:'X-CSRFToken'}
          }).then(response => 
          { 
            if(response.managedError) {
              const result = response.result.data 
              
              if (result.log.type == "INFO") {
                dispatch({
                  type: "SET_ACCESS_TOKEN",
                  payload: {user:result["user"], accessToken: result["access_token"] }
                });
                history.push('/information')
              } 
              else
                setUser({...userData, log:{type:result.log.type, text:result.log.text, style:result.log.style, activeResendEmail:result.activeReSendEmail}})
              
            }
            else {
              setUser({...userData, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
            }
            })
      
    }
    else
      setUser(userData);
  }

  const refreshForm = () => {
  
    const userData = { 
      id: 1,
      email : "",
      password : "",
      errors:[],
      loading:false
    }
   
    setUser(userData);
  }

  const getTitle = () => {
    return <React.Fragment>
      <div style = {{display:"flex",  marginLeft:"auto", marginRight:"auto",  width:"1040px", borderRadius: "4px", marginTop:"5px" }}>
        <div style = {{minWidth:"302px", maxWidth:"302px" }}></div>
        {[...(new Array(1))].map( item => 
         <React.Fragment>
          <div style = {{ display:"flex",  minWidth:"744px",  maxWidth:"744px", fontSize:"12px", paddingTop:"3px"
          , minHeight:"24px",  maxHeight:"24px",backgroundColor: "white"
          ,boxSizing: "border-box"   , borderRight:"1px solid #f2f3f5" }}>
            <div style = {{marginTop:"-3px" }}>
              <PreviousIcon />
            </div>
            <div style = {{marginLeft:"auto", marginRight:"auto" }}>2022</div>
            <div style = {{marginTop:"-3px" }}>
              <NextIcon />
            </div>
          </div>
        </React.Fragment>
        )}
      </div>
    </React.Fragment>
  }
  const getMonth = () => {
    return <React.Fragment>
      <div style = {{display:"flex",  marginLeft:"auto", marginRight:"auto",  width:"1040px", borderRadius: "4px", marginTop:"1px" }}>
        <div style = {{minWidth:"302px", maxWidth:"302px" }}></div>
        {[...(new Array(12))].map( (_, item) => 
         <React.Fragment>
          <div style = {{ textAlign:"center", minWidth:"62px",  maxWidth:"62px", fontSize:"12px", paddingTop:"3px"
          , minHeight:"24px",  maxHeight:"24px",backgroundColor: "white"
          ,boxSizing: "border-box"   , borderRight:"1px solid #f2f3f5"  }}>
            {months[item]}
          </div>
        </React.Fragment>
        )}
      </div>
    </React.Fragment>
  }

 
  const getDay = () => {
    return <React.Fragment>
      <div style = {{display:"flex",  marginLeft:"auto", marginRight:"auto",  width:"1040px", borderRadius: "4px", marginTop:"1px" }}>
        <div style = {{minWidth:"302px", maxWidth:"302px" }}></div>
        {[...(new Array(31))].map( (_, item) => 
         <React.Fragment>
          <div style = {{ textAlign:"center",  minWidth:"24px",  maxWidth:"24px", fontSize:"12px", paddingTop:"3px"
          , minHeight:"24px",  maxHeight:"24px",backgroundColor: "white"
          ,boxSizing: "border-box"   , borderRight:"1px solid #f2f3f5" }}>
            {item < 9 ? "0" + (item+ 1) : item +1 }
          </div>
        </React.Fragment>
        )}
      </div>
    </React.Fragment>
  }
  const getHour = () => {
    return <React.Fragment>
      <div style = {{display:"flex",  marginLeft:"auto", marginRight:"auto",  width:"1040px", borderRadius: "4px", marginTop:"1px" }}>
        <div style = {{minWidth:"302px", maxWidth:"302px" }}></div>
        
        {[...(new Array(46))].map( (_, item) => 
          <div style = {{ textAlign:"center", minWidth:"31px",  maxWidth:"31px", fontSize:"12px", paddingTop:"3px"
          , minHeight:"24px",  maxHeight:"24px",backgroundColor: "white"
          ,boxSizing: "border-box"   , borderRight:"1px solid #f2f3f5" }}>
            {item <= 9 ? "0" + item : item }
          </div>
        )}
      </div>
    </React.Fragment>
  }

  const getSubTitle = () => {
  
    switch (data.chartType) {
      case "Day":
        return getHour()
      case "Month":
        return getDay()
      case "Year":
        return getMonth()
    }
   
  }
  

  const getList = () => {
    return <Steps />
  }

  const getGanttChart = () => {
  
  
    return  <React.Fragment>       
              {getHeader()}
              <div style = {{display:"flex",  marginLeft:"auto", marginRight:"auto",  width:"1040px", borderRadius: "4px", marginTop:"5px" }}>
              <Process isExpanded = {process.includes(1)} onClickProcessIcon  = { () => onClickProcessIcon(1) } />        
              {[...(new Array(31))].map( item => 
                <div style = {{minWidth:"24px",  maxWidth:"24px", minHeight:"24px",  maxHeight:"24px"
                  ,boxSizing: "border-box"   , borderRight:"1px solid #f2f3f5",backgroundColor: "white" }}>
                </div>      
              )}      
              </div>
            </React.Fragment>
  }

  const getHeader = () => {
  
  
    return <React.Fragment>
     
     
      {getTitle()}
      {getSubTitle()}

     
  
    </React.Fragment>
  }

  const onClickProcessIcon = (id) => {
  
   if (process.includes(id))
    setProcess(process.filter(item => item != id));
  else
  setProcess([...process, id]);
  }

  const canClick = user.errors.length == 0 && !user.loading

  return (
    <React.Fragment>
      <div style = {{ display: "flex", marginLeft:"auto", marginRight:"auto",  width:"1047px"
        , minHeight: "40px", borderRadius: "4px"
        , marginTop:"30px", backgroundColor: "white" }}>
        <div style = {{ marginLeft:"15px", marginRight:"10px",marginTop:"8px"}}>Number :</div>
        <input type="textBox" placeholder="Number" value={user.firstName}  
         
          style = {{marginTop:"5px", height:"30px", width:"150px"  }}
          className="textBox" />
        <div style = {{ marginLeft:"15px", marginRight:"10px",marginTop:"8px"}}>Full Name :</div>
        <input type="textBox" placeholder="Full Name" value={user.firstName}  
          readOnly
          style = {{marginTop:"5px", height:"30px", width:"180px", border:"none"  }}
          className="textBox" />
        <div style = {{ marginLeft:"15px", marginRight:"10px",marginTop:"8px"}}>Process :</div>
        <input type="textBox" placeholder="Process" value={user.firstName}  
          readOnly
          style = {{marginTop:"5px", height:"30px", width:"200px", border:"none"  }}
          className="textBox" />
        <div style = {{ marginLeft:"15px", marginRight:"10px",marginTop:"8px"}}>Step :</div>
        <input type="textBox" placeholder="Step" value={user.firstName}  
          readOnly
          style = {{marginTop:"5px", height:"30px", width:"130px", border:"none"  }}
          className="textBox" />
      </div>
      <div style = {{ display: "flex", marginLeft:"auto", marginRight:"auto",  width:"1047px"
        , minHeight: "40px", borderRadius: "4px"
        , marginTop:"5px", backgroundColor: "white" }}>
        <div style = {{ marginLeft:"15px",marginTop:"5px", marginRight:"10px"}}>
          <DropDownListNew
            fontSize={"14px"}
            currentData={[{id:1, item:"List"},{id:2, item:"Gantt Chart"}]}
            id={"OptionsList"}
            initialValue={data.option.item}
            onDropDownItemClick={(itemSelected) => setData({...data, option:itemSelected})}
            onlyLabel={false}/>
        </div>
        <div style = {{ marginLeft:"15px", marginTop:"5px", marginRight:"10px"}}>
          <DropDownListNew
            fontSize={"14px"}
            currentData={[{id:1, item:"Day"},{id:2, item:"Month"},{id:3, item:"Year"}]}
            id={"UsersList"}
            initialValue={data.chartType}
            onDropDownItemClick={(itemSelected) => setData({...data, chartType:itemSelected.item})}
            onlyLabel={false}/>
        </div>
      </div>
      
      { data.option.id == 2 ? getGanttChart() : getList()}
      
      
      </React.Fragment>
  );
};

/*
<span style = {{ fontSize:"14px", width:"250px", color:"#212121" }} >Register</span>*/